export const DATABASE_TYPE = process.env.REACT_APP_DB_CONFIG;
export const PTS_DATABASE = 'PTS';
